import { LanguageSelector } from './language-selector';
import { LegalLinks } from './legal-links';
import { useLocale } from '@/lib/locale-context';

/** The strip under every card: smallprint left, language right. */
export function PageFooter() {
  const { locale } = useLocale();
  return (
    <div className="flex items-center justify-between gap-4">
      <LegalLinks locale={locale} />
      <LanguageSelector />
    </div>
  );
}
